import React, { createContext, useContext } from "react";
export const DefaultContextState = {
  flex: false
};
export const Context = /*#__PURE__*/createContext(DefaultContextState);
export function AbleToProvider({
  config: configOverride = {},
  children
}) {
  const config = Object.assign(DefaultContextState, configOverride);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: config
  }, children);
}
export function useAbleToProvider() {
  return useContext(Context) ?? DefaultContextState;
}
//# sourceMappingURL=index.js.map